import React, { useEffect, useState } from 'react';
import services from '../../services';
import { toast } from 'react-toastify';
import axios from 'axios';
import Automations from './Automations';
import DeletePopup from '../DeletePopup';
import AppModal from '../../common/AppModal';
import { FiZap, FiPlus, FiEdit2, FiTrash2, FiSearch, FiX } from 'react-icons/fi';
import AppSelect from '../../common/AppSelect';
import './AllAutomation.css';

const AllAutomation = ({ show, onHide, step, setStep, setAutomations, editId, setEditId }) => {
    const [automations, setAutomationsState] = useState([]);
    const [existautomation, setExistautomation] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userList, setUserList] = useState([]);
    const [deleteId, setDeleteId] = useState(null);
    const [deletemodal, setDeletemodal] = useState(false);
    const [boardList, setBoardList] = useState([]);
    const [columnList, setColumnList] = useState([]);
    const [boardName, setBoardName] = useState([]);
    const [filterList, setFilterList] = useState([]);

    const [selectedType, setSelectedType] = useState('');
    const [selectedName, setSelectedName] = useState('');
    const [selectedGmailUserId, setSelectedGmailUserId] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const getAllAutomation = async (signal) => {
        setLoading(true);
        try {
            let query = `isColumnAutomation=false`;
            if (selectedType) query += `&type=${selectedType}`;
            if (selectedName) query += `&name=${selectedName}`;
            if (selectedGmailUserId) query += `&gmailUserId=${selectedGmailUserId}`;
            if (searchTerm) query += `&search=${encodeURIComponent(searchTerm)}`;

            const response = await services.automations.GET_ALL_AUTOMATIONS(query, { signal });

            if (response) {
                setAutomationsState(response || []);
                if (response?.data?.data?.length > 0) {
                    setExistautomation(true);
                }
            }
        } catch (e) {
            if (e.name === 'AbortError' || e.name === 'CanceledError') return;
            toast.error('Failed to fetch automations');
            setAutomationsState([]);
        }
        setLoading(false);
    };

    useEffect(() => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => {
            getAllAutomation(controller.signal);
        }, 500);
        return () => {
            clearTimeout(timeoutId);
            controller.abort();
        };
    }, [selectedType, selectedName, selectedGmailUserId, searchTerm]);

    useEffect(() => {
        const getUserById = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/getAllUser`);
                if (response?.data?.data?.users) {
                    setUserList(response?.data?.data?.users);
                }
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };

        const getGmailUsers = async () => {
            try {
                const response = await services.email.Get_The_Linked_Email();
                if (response?.data) {
                    const gmailOptions = response.data.map((item) => ({
                        value: item.id,
                        label: item.email,
                    }));
                    setFilterList(gmailOptions);
                }
            } catch (error) {
                console.error('Error fetching Gmail users:', error);
            }
        };

        getUserById();
        getGmailUsers();
        getAllBoardDateTable();
    }, []);

    const getAllBoardDateTable = async () => {
        try {
            const response = await services.board.GET_BOARD_LIST();
            if (response) {
                setBoardList(response?.data?.data);
                const boardNameOptions =
                    response?.data?.data?.map((board) => ({
                        label: board.boardName,
                        value: board.id,
                    })) || [];
                setBoardName(boardNameOptions);
                const boardColumnsMap = {};
                response?.data?.data?.forEach((board) => {
                    if (board.BoardLists && board.BoardLists.length > 0) {
                        boardColumnsMap[board.id] = board.BoardLists.map((column) => ({
                            id: column.id,
                            name: column.coloum,
                            color: column.colour,
                            sequence: column.sequence,
                        }));
                    }
                });
                setColumnList(boardColumnsMap);
            }
        } catch (error) {
            console.error('Error fetching board date table:', error);
        }
    };

    const getUserNameById = (id) => {
        const user = userList.find((u) => u.id === id);
        return user ? user.name : 'N/A';
    };

    const getBoardNameById = (id) => {
        const board = boardList.find((b) => b.id === id);
        return board ? board.boardName : 'N/A';
    };

    const getColumnNameById = (boardId, columnId) => {
        if (columnList[boardId]) {
            const column = columnList[boardId].find((col) => col.id === columnId);
            return column ? column.name : 'N/A';
        }
        return 'N/A';
    };

    const getColumnsByBoardId = (boardId) => {
        return columnList[boardId] || [];
    };

    const getBoardIdFromAutomation = (auto) => {
        if (auto.type === 'new') {
            const createOnListAction = auto.action?.find((action) => action.action === 'createOnList');
            return createOnListAction?.boardId;
        }
        return auto.condition?.find((c) => c.operand === 'board')?.value;
    };

    const handleEdit = (id) => {
        setStep(2);
        setAutomations(true);
        setEditId(id);
    };

    const handleDelete = (id) => {
        setDeleteId(id);
        setDeletemodal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            await services.automations.DELETE_BY_ID_AUTOMATIONS(deleteId);
            toast.success('Automation deleted successfully');
            setDeletemodal(false);
            setDeleteId(null);
            getAllAutomation();
        } catch (e) {
            toast.error('Failed to delete automation');
        }
    };

    const formatConditions = (conditions = [], boardList = [], columnList = {}, automationType = '', gmailUserId = '') => {
        if (!Array.isArray(conditions) || conditions.length === 0) return [];
        const formattedConditions = conditions.map((cond) => {
            let label = '';
            let value = cond.value;
            switch (cond.operand) {
                case 'title': label = 'Title'; break;
                case 'listName':
                    label = 'List';
                    for (const boardId in columnList) {
                        const column = columnList[boardId]?.find((col) => col.id === cond.value);
                        if (column) { value = column.name; break; }
                    }
                    break;
                case 'board':
                    label = 'Board';
                    const board = boardList.find((b) => b.id === cond.value);
                    if (board) value = board.boardName;
                    break;
                case 'assignee':
                    label = 'Assignee';
                    if (Array.isArray(cond.value)) {
                        const userIds = cond.value.map((item) => item.entityId).filter(Boolean);
                        value = userIds.map((userId) => getUserNameById(userId)).join(', ');
                    } else if (cond.value && typeof cond.value === 'object' && cond.value.entityId) {
                        value = getUserNameById(cond.value.entityId);
                    } else if (typeof cond.value === 'string') {
                        value = getUserNameById(cond.value);
                    }
                    break;
                case 'subject': label = 'Subject'; break;
                case 'sender': label = 'From email address'; break;
                case 'recipient': label = 'To email address'; break;
                case 'customerWaiting': label = 'the customer has been waiting'; break;
                case 'customerNotResponding': label = 'the team has been waiting'; break;
                default: label = cond.operand;
            }
            let operatorText = '';
            switch (cond.operator) {
                case 'equals': operatorText = 'equals'; break;
                case 'doesNotContain': operatorText = 'does not contain'; break;
                case 'contains': operatorText = 'contains'; break;
                case 'moreThanMins': operatorText = 'more than (minutes)'; break;
                case 'moreThanHrs': operatorText = 'more than (hours)'; break;
                case 'moreThanDays': operatorText = 'more than (days)'; break;
                default: operatorText = cond.operator;
            }
            return `${label} ${operatorText} "${value}"`;
        });
        if (automationType === 'new' && gmailUserId) {
            const gmailUser = filterList.find((user) => user.value === gmailUserId);
            if (gmailUser) formattedConditions.unshift(gmailUser.label);
        }
        return formattedConditions.join(', ');
    };

    const formatActions = (actions = []) => {
        if (!Array.isArray(actions) || actions.length === 0) return [];
        return actions.map((act) => {
            switch (act.action) {
                case 'createOnList':
                    return `Create task on list: ${getColumnNameById(act.boardId, act.entityId)}`;
                case 'assignTo':
                    return `Assign to ${getUserNameById(act.entityId)}`;
                case 'assignToRoundRobin':
                    if (act.entityIds && Array.isArray(act.entityIds)) {
                        return `Assign with round robin to ${act.entityIds.map((u) => getUserNameById(u.entityId)).join(', ')}`;
                    }
                    return act.entityId ? `Assign with round robin to ${getUserNameById(act.entityId)}` : 'Assign with round robin';
                case 'unassign': return 'Unassign task';
                case 'markComplete': return 'Mark task as complete';
                case 'markIncomplete': return 'Mark task as incomplete';
                case 'moveToNext': return 'Move task to next list';
                case 'moveToPreviousList': return 'Move task to previous list';
                case 'sendOverdueAlert': return act.message ? `Send overdue alert: "${act.message}"` : 'Send overdue alert';
                case 'sendFollowUpToCustomer':
                    return act.templateHtml ? `Create Follow-up Reminder: "${act.templateHtml.replace(/<[^>]*>/g, '')}"` : 'Create Follow-up Reminder';
                case 'sendUpcomingAlert': return act.message ? `Send upcoming alert: "${act.message}"` : 'Send upcoming alert';
                case 'sendNotificationTo': return act.entityId ? `Send notification to ${getUserNameById(act.entityId)}` : 'Send notification';
                case 'setSlaAlertTag': return act.entityValue && Array.isArray(act.entityValue) ? `Set SLA Alert Tag: ${act.entityValue.join(', ')}` : 'Set SLA Alert Tag';
                case 'subEmailInbox': return 'Skip inbox processing';
                case 'emailInbox': return act.hasReply !== undefined ? `Email inbox (hasReply: ${act.hasReply === true ? 'skip' : 'not skip'})` : 'Email inbox';
                default: return act.action;
            }
        }).join(', ');
    };

    const typeLabelMap = {
        itemAdded: 'Item Added to List',
        new: 'New Email Received',
        noReplyFromCustomer: 'No Reply From Customer',
        noReplyToCustomer: 'No Reply To Customer',
        default: 'Unknown Type',
    };

    const hasActiveFilters = selectedType || selectedGmailUserId || searchTerm;

    return (
        <>
            <AppModal
                show={show}
                onClose={onHide}
                icon={<FiZap size={17} color="#fff" />}
                title="Automations"
                subtitle="Manage your workflow automations"
                maxWidth="920px"
                footer={
                    <button
                        className="btn-primary-green"
                        onClick={() => {
                            setStep(2);
                            setEditId(null);
                            setAutomations(true);
                        }}
                    >
                        <FiPlus size={14} />
                        Create Automation
                    </button>
                }
            >
                {/* ── Filter bar ── */}
                <div className="aa-filter-bar">
                    <div className="aa-search-wrapper">
                        <span className="aa-search-icon">
                            <FiSearch size={14} />
                        </span>
                        <input
                            type="text"
                            placeholder="Search automations..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="aa-search-input"
                        />
                    </div>

                    <AppSelect
                        value={selectedType}
                        onChange={(e) => setSelectedType(e.target.value)}
                        placeholder="All Types"
                        options={[
                            { value: '', label: 'All Types' },
                            { value: 'itemAdded', label: 'Item Added to List' },
                            { value: 'new', label: 'New Email Received' },
                            { value: 'noReplyFromCustomer', label: 'No Reply From Customer' },
                            { value: 'noReplyToCustomer', label: 'No Reply To Customer' },
                        ]}
                    />

                    <AppSelect
                        value={selectedGmailUserId}
                        onChange={(e) => setSelectedGmailUserId(e.target.value)}
                        className="aa-select--wide"
                        placeholder="All Emails"
                        options={[
                            { value: '', label: 'All Emails' },
                            ...filterList,
                        ]}
                    />

                    {hasActiveFilters && (
                        <button
                            className="aa-btn-reset"
                            onClick={() => {
                                setSelectedType('');
                                setSelectedName('');
                                setSelectedGmailUserId('');
                                setSearchTerm('');
                            }}
                        >
                            <FiX size={13} />
                            Reset
                        </button>
                    )}
                </div>

                {/* ── Table ── */}
                <div className="data-table-card">
                    <div className="data-table-scroll">
                        <table className="data-table">
                            {automations.length > 0 && (
                                <thead>
                                    <tr className="data-table__head-row">
                                        <th className="data-table__th" style={{ width: '14%' }}>Board</th>
                                        <th className="data-table__th" style={{ width: '18%' }}>Type</th>
                                        <th className="data-table__th" style={{ width: '28%' }}>Conditions</th>
                                        <th className="data-table__th" style={{ width: '28%' }}>Actions</th>
                                        <th className="data-table__th" style={{ width: '12%' }}></th>
                                    </tr>
                                </thead>
                            )}
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={5} className="loader-cell">
                                            <div className="loader-inner">
                                                <div className="loader-spinner" />
                                                <span className="loader-text">Loading automations…</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : automations.length === 0 ? (
                                    <tr>
                                        <td colSpan={5}>
                                            <div className="empty-state">
                                                <FiZap size={40} color="#d1d5db" />
                                                <p className="empty-state__text">No automations yet — create your first one</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    automations.map((auto) => (
                                        <tr key={auto.id} className="data-table__row">
                                            <td className="data-table__td data-table__td--badge">
                                                <span
                                                    className="badge-board"
                                                    title={getBoardNameById(getBoardIdFromAutomation(auto))}
                                                >
                                                    {getBoardNameById(getBoardIdFromAutomation(auto))}
                                                </span>
                                            </td>
                                            <td className="data-table__td data-table__td--badge">
                                                <span
                                                    className="badge-type"
                                                    title={typeLabelMap[auto.type] || typeLabelMap.default}
                                                >
                                                    {typeLabelMap[auto.type] || typeLabelMap.default}
                                                </span>
                                            </td>
                                            <td className="data-table__td--muted">
                                                <span
                                                    className="truncate-cell"
                                                    title={formatConditions(auto.condition, boardList, columnList, auto.type, auto.when?.gmailUserId)}
                                                >
                                                    {formatConditions(auto.condition, boardList, columnList, auto.type, auto.when?.gmailUserId) || '—'}
                                                </span>
                                            </td>
                                            <td className="data-table__td--muted">
                                                <span
                                                    className="truncate-cell"
                                                    title={formatActions(auto.action)}
                                                >
                                                    {formatActions(auto.action) || '—'}
                                                </span>
                                            </td>
                                            <td className="data-table__td data-table__td--right">
                                                <div className="action-group">
                                                    <button
                                                        className="btn-icon-edit"
                                                        title="Edit automation"
                                                        onClick={() => handleEdit(auto.id)}
                                                    >
                                                        <FiEdit2 size={13} />
                                                    </button>
                                                    <button
                                                        className="btn-icon-delete"
                                                        title="Delete automation"
                                                        onClick={() => handleDelete(auto.id)}
                                                    >
                                                        <FiTrash2 size={13} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </AppModal>

            {automations && step === 2 && (
                <Automations
                    show={automations}
                    setAutomations={setAutomations}
                    onHide={onHide}
                    boardName={boardName}
                    gmailUsers={filterList}
                    step={step}
                    setStep={setStep}
                    editId={editId}
                    setEditId={setEditId}
                    getAllAutomation={getAllAutomation}
                />
            )}

            <DeletePopup
                open={deletemodal}
                title="Are you sure you want to delete this automation?"
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeletemodal(false)}
                confirmLabel="YES, I'M SURE"
                cancelLabel="NO"
            />
        </>
    );
};

export default AllAutomation;
